import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { clsx } from 'clsx';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
  selector: 'sb-summary-item',
  templateUrl: './summary-item.component.html',
})
export class SummaryItemComponent implements OnChanges {
  cellClasses = 'flex gap-2';
  rowClasses = clsx('flex items-center justify-between gap-2 leading-6 whitespace-nowrap');

  @HostBinding('class')
  class = clsx('flex w-full flex-col gap-1 overflow-hidden');

  @Input()
  compact = false;

  ngOnChanges(changes: SimpleChanges) {
    // When these classes are updated, don't forget to reflect that in the template defined classes of the `thirdRowLeft` as well
    this.cellClasses = clsx(['flex gap-2', changes['compact'] ? 'text-sm leading-6' : '']);
  }
}
